'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {ViewMode, ViewModePropType} from '../../../core-utilities/enums/ViewMode';

const loadingIcon = require('../../../../img/loading.svg');
const successIcon = require('../../../../img/success.svg');
const noDataIcon = require('../../../../img/no-data.svg');
const noNetworkIcon = require('../../../../img/no-network.svg');
const errorIcon = require('../../../../img/error.svg');

export function StatusOverlayComponent(props) {
  switch (props.mode) {
    case ViewMode.LOADING:
      return statusOverlay({
        className: props.overlayClassName,
        showIcon: true,
        icon: loadingIcon,
        label: props.loadingLabel,
        showRetry: false,
      });
    case ViewMode.NO_DATA:
      if (props.showNoData) {
        return statusOverlay({
          className: props.overlayClassName,
          showIcon: props.showNoDataIcon,
          icon: props.noDataIcon || noDataIcon,
          useNoDataImage: props.useNoDataImage,
          title: props.noDataTitle,
          label: props.noDataLabel,
          showRetry: false,
        });
      } else {
        return null;
      }
    case ViewMode.ENONET:
      return statusOverlay({
        className: props.overlayClassName,
        showIcon: true,
        icon: noNetworkIcon,
        label: props.noNetworkLabel,
        showRetry: props.showRetry,
      });
    case ViewMode.EOTHER:
      // consider displaying the error message to the user
      return statusOverlay({
        className: props.overlayClassName,
        showIcon: true,
        icon: errorIcon,
        label: props.errorLabel,
        showRetry: props.showRetry,
      });
    case ViewMode.SUCCESS:
      if (props.showSuccess) {
        return statusOverlay({
          className: props.overlayClassName,
          showIcon: true,
          icon: successIcon,
          label: props.successLabel,
          showRetry: false,
        });
      } else {
        return null;
      }
    default:
      return null;
  }
}

function statusOverlay(props) {
  return (
    <div
      className={classNames("StatusOverlay", props.overlayClassName, {
        StatusOverlay_noIcon: !props.showIcon,
      })}
    >
      <div className="StatusOverlay__container">
        {!props.showIcon ? null : (
          <img
            className={classNames("StatusOverlay__image", {
              StatusOverlay__image_custom: props.useNoDataImage,
            })}
            src={props.icon}
          />
        )}
        {props.title && (
          <div className="StatusOverlay__title">
            {props.title}
          </div>
        )}
        <div className={classNames("StatusOverlay__message", {
          StatusOverlay__message_withTitle: !!props.title,
        })}
        >
          {props.label}
        </div>
      </div>
    </div>
  );
}

function retryButton(props) {
  if (props.showRetry) {
    return (
      <button
        className="StatusOverlay__retry"
        onClick={props.onClickRetry}
      >
        Retry
      </button>
    );
  } else {
    return null;
  }
}

StatusOverlayComponent.propTypes = {
  overlayClassName: T.string,
  mode: ViewModePropType.isRequired,
  showSuccess: T.bool,
  showNoData: T.bool,
  showNoDataIcon: T.bool,
  useNoDataImage: T.bool,
  showRetry: T.bool,

  onClickRetry: T.func,

  successLabel: T.string,
  loadingLabel: T.string,
  noDataTitle: T.string,
  noDataLabel: T.string,
  noNetworkLabel: T.string,
  errorLabel: T.string,

  // Overwrite icons
  noDataIcon: T.node,
};

StatusOverlayComponent.defaultProps = {
  showSuccess: false,
  showNoData: true,
  showNoDataIcon: true,
  useNoDataImage: false,
  showRetry: false,
  loadingLabel: 'Loading',
  noDataLabel: 'No Data',
  noNetworkLabel: 'The server could not be reached.',
  errorLabel: 'An error occurred.',
};



// WEBPACK FOOTER //
// ./src/js/core-components/loading-icon/components/StatusOverlayComponent.js